export default val => {
  const typeUser = {
    'administrator': 'Administrador',
    'general_manager': 'Director',
    'manager': 'Gerente',
    'seller': 'Vendedor'
  }
  return typeUser[val]
}